/*
 *
 *  * Copyright (c) 2021 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'age'
})
export class AgePipe implements PipeTransform {
  transform(date: any): number {
    if (date == undefined) {
      return 0;
    }
    if (typeof date != 'number') {
      date = Date.parse(date.toString());
    }
    const timeDiff = Math.abs(Date.now() - date);
    return Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
  }
}
